import React from 'react';
import style from './CheckBox.module.css';
import PropTypes from 'prop-types';
import { fontSizes } from '../../text/Text';

function CheckBox({
  children,
  checked,
  onChange,
  fontSize,
  margin,
  disabled,
  color,
}) {
  return (
    <label className={style.checkbox} style={{ fontSize, margin, color }}>
      <span className={style.checkbox__input}>
        <input
          disabled={disabled}
          type="checkbox"
          name="checkbox"
          checked={checked}
          onChange={({ target }) => onChange(target.checked)}
        />
        <span className={style.checkbox__control}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            aria-hidden="true"
            focusable="false"
          >
            <path
              fill="none"
              stroke="currentColor"
              strokeWidth="4"
              d="M1.73 12.91l6.37 6.37L22.79 4.59"
            />
          </svg>
        </span>
      </span>
      <span style={{ color }} className={style.radio__label}>
        {children}
      </span>
    </label>
  );
}
CheckBox.defaultProps = {
  fontSize: fontSizes.body3,
  margin: '0',
  disabled: false,
};
CheckBox.propTypes = {
  children: PropTypes.any,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  fontSize: PropTypes.string,
  margin: PropTypes.string,
  disabled: PropTypes.bool,
  color: PropTypes.string,
};
export default CheckBox;
